const quicklinks = [
  {
    title: "Women",
    path: "women",
    icon: "./images/quicklinks/Quicklink01-Women.jpg",
  },
  {
    title: "Men",
    path: "men",
    icon: "./images/quicklinks/Quicklink02-Men.jpg",
  },
  {
    title: "Kids",
    path: "kids",
    icon: "./images/quicklinks/Quicklink03-Kids.jpg",
  },
  {
    title: "Homeware",
    path: "homeware",
    icon: "./images/quicklinks/Quicklink04-homeware.jpg",
  },
];

export default quicklinks;
